<template>
  <el-form
    label-width="80px"
    class="flex flex-wrap justify-items-start items-center"
  >
    <slot></slot>
    <el-form-item
      v-for="(item, index) in options"
      :label="item['label']"
      :prop="item['field']"
      :key="index"
    >
      <el-input
        v-if="item['type'] === 'input'"
        v-model.trim="formdata[item.field]"
        :disabled="item['disabled']"
        :placeholder="item.placeholder"
        clearable
      ></el-input>
      <el-input-number
        v-if="item['type'] === 'number'"
        v-model="formdata[item.field]"
        :disabled="item['disabled']"
        :placeholder="item.placeholder"
      ></el-input-number>
      <el-radio-group
        v-if="item['type'] === 'radio'"
        v-model="formdata[item.field]"
        :disabled="item['disabled']"
      >
        <el-radio-button
          v-for="(part, i) in item['options']"
          :label="part['id']"
          :key="i"
          >{{ part["name"] }}</el-radio-button
        >
      </el-radio-group>
      <el-select
        :clearable="
          Object.keys(item).includes('clearable') ? item.clearable : true
        "
        v-if="item['type'] === 'select'"
        v-model="formdata[item.field]"
        :disabled="item['disabled']"
        :placeholder="item.placeholder"
      >
        <el-option
          v-for="(part, i) in item['options']"
          :key="i"
          :label="part.name"
          :value="part['id']"
        >
        </el-option>
      </el-select>

      <el-date-picker
        :clearable="
          Object.keys(item).includes('clearable') ? item.clearable : true
        "
        v-if="item['type'] === 'year'"
        v-model="formdata[item.field]"
        type="year"
        format="yyyy"
        value-format="yyyy"
        placeholder="选择年"
        :disabled="item['disabled']"
      >
      </el-date-picker>
      <el-cascader
        :clearable="
          Object.keys(item).includes('clearable') ? item.clearable : true
        "
        v-if="item['type'] === 'cascader'"
        v-model="formdata[item.field]"
        :options="item.options"
        :disabled="item['disabled']"
      ></el-cascader>
    </el-form-item>
    <el-form-item label-width="10px">
      <el-button type="primary" @click="handleFind()">查 询</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  name: "",
  components: {},
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    formdata: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    /**
     *  @actions:    抛出查询事件
     *  @content:
     *  @Autor: Silence
     *  @Date: 2023-04-26 11:35:44
     *  @params:
     *          <参数名称>  参数标题  参数类型    默认值
     **/
    handleFind() {
      this.$emit("onSearch");
    },
  },
};
</script>
<style lang="scss" scoped></style>
